import { useCallback, useRef } from 'react';
import { toMoneyInputValue } from 'utilities/currencyFormatter';

// Money inputs open with the missing cent digit added (1002.5 -> '1002.50'; whole dollars like 500 stay as they are).
// Once the user types in a field it shows exactly what they typed, so the padding never fights the cursor.
// The stored value is never changed, only what the input shows.
//
//   const moneyInput = useMoneyInputs();
//   <TextField type="number" {...moneyInput('amount', values.amount, handleChange)} />
//
// `name` only has to be unique within the form (e.g. `${index}.amount` for repeated rows).
export const useMoneyInputs = () => {
  const typedFields = useRef(new Set());

  return useCallback(
    (name, value, onChange) => ({
      value: typedFields.current.has(name) ? value : toMoneyInputValue(value),
      onChange: event => {
        typedFields.current.add(name);
        onChange(event);
      },
    }),
    [],
  );
};
